import { Buffer as _Buffer } from "buffer";
export default {
  serialize(buffer) {
    return _Buffer.from(buffer);
  },
  deserialize(buffer) {
    return buffer;
  }
};
//# sourceMappingURL=raw.js.map